import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import SearchAuto from "../LocationAutoComplete/SearchAuto";

const BusinessProfile = (props) => {
  const [disabled, setDisabled] = useState(false);
  const [aBn, setAbn] = useState("");
  const [isSubmit, setIsSumbit] = useState(false);
  const [role, setRole] = useState("local_business")

  useEffect(() => {
    setAbn(props.data.abn);
  }, [props]);

  const handleSubmit = (values) => {
    localStorage.setItem("user_profile_role", role);
    if (props.location_text && props.cordinate) {
      if (disabled) {
        values.abn = "";
        props.next(values);
      } else if (!disabled && aBn.length >= 11) {
        values.abn = aBn;
        props.next(values);
      }
    }
  };

  const handleInputChange = (event) => {
    if (event.target.value === "on") {
      setDisabled(true);
    }
  };

  const stepOneValidationSchema = Yup.object({
    name: Yup.string().required("Name is a required field"),
    mobile: Yup.number().typeError("Please add only numbers"),
  });
  return (
    <div className="businessprofile-cover">
      <h1>Let’s build your profile</h1>
      <Formik
        enableReinitialize={true}
        initialValues={props.data}
        onSubmit={handleSubmit}
        validationSchema={stepOneValidationSchema}
      >
        {() => (
          <Form className="business-profile-form">
            <div className="form-group">
              <label>Establishment Type</label>
              <select
                className="form-control"
                onChange={(e) => {
                  props.setProfileType(e.target.value);
                  setRole(e.target.value)
                }}
              >
                <option
                  value="local_business"
                  label="Local Business"
                  selected
                />
                <option value="club" label="Club" />
              </select>
            </div>

            {/* <div className="form-group">
              <label>Establishment Type</label>
              <select className="form-control">
                <option value="1">Club</option>
                <option value="2">Local Business</option>
              </select>
            </div> */}
            <div className="form-group">
              <label>
                {props.profileType === "club" ? "Club" : "Business"} Name
              </label>
              <Field name="name" type="text" className="form-control" />
              <ErrorMessage
                name="name"
                component="div"
                className="error-message"
              />
            </div>
            {props.profileType !== "club" && (
              <div className="form-group">
                <label>Phone Number</label>
                <Field name="mobile" type="tel" className="form-control" />
                <ErrorMessage
                  name="mobile"
                  component="div"
                  className="error-message"
                />
              </div>
            )}
            <div className="form-group map-input">
              <label>Address</label>
              <div className="search-group">
                <SearchAuto
                  setLocation_text={props.setLocation_text}
                  setCordinate={props.setCordinate}
                  location_text={props.location_text}
                />
                {(!props.setCordinate || !props.location_text) && isSubmit ? (
                  <div className="error-message">
                    Address is a required field
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="form-group">
              <label>ABN</label>
              <input
                disabled={disabled}
                name="abn"
                type="text"
                className="form-control"
                onChange={(e) => {
                  if (e.target.value.length <= 11) {
                    setAbn(e.target.value);
                  }
                }}
                value={aBn}
              />
              {!disabled && isSubmit && aBn.length < 11 ? (
                <div className="error-message">Must have 11 digits</div>
              ) : (
                ""
              )}
              <div className="radio">
                <label className="radio-btn">
                  I’ll add my ABN later
                  {/* <Field name="abn2" type="checkbox" className="form-control" /> */}
                  <input
                    onChange={handleInputChange}
                    type="radio"
                    name="radio"
                  />
                  <span className="checkmark-radio"></span>
                </label>
              </div>
            </div>
            <div className="form-submit">
              <button
                type="submit"
                className="submit-btn"
                onClick={() => {
                  setIsSumbit(true);
                }}
              >
                Next
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default BusinessProfile;
